import 'slick-carousel';

class Sliders {
  constructor() {
    this.settings = {
      slider: '.js-flipbooks-slider',
      experiences: '.js-experiences-slider',
    };
  }

  init() {
    import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
      window.addEventListener('resize', () => {
        this.reInit();
      });
      const $element = $(this.settings.slider);
      const $exp = $(this.settings.experiences);
      $(window).on('load resize orientationchange', () => {
        $element.map((key, item) => {
          const $item = $(item);
          if ($item.hasClass('js-flipbooks-slider--custom') && $(window).width() > 991) {
            if ($item.hasClass('slick-initialized')) {
              $item.slick('unslick');
            }
          } else if (!$item.hasClass('slick-initialized')) {
            $item.slick(this.constructor.sliderSettings($item));
          }
          return item;
        });
      });
      $exp.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              arrows: false,
              dots: true,
              autoplay: true,
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 450,
            settings: {
              dots: true,
              autoplay: false,
              slidesToShow: 1,
            },
          },
        ],
      });
    });
  }

  static sliderSettings(item) {
    return {
      slidesToShow: $(item).hasClass('two') ? 2 : 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      speed: 300,
      autoplay: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 500,
          settings: {
            autoplay: false,
            slidesToShow: 1,
          },
        },
      ],
    };
  }

  reInit() {
    const $element = $(this.settings.slider);
    $(() => {
      $($element).each((key, item) => {
        const $item = $(item);
        if ($item.hasClass('slick-initialized')) {
          $item.slick('unslick').slick(this.constructor.sliderSettings($item));
        }
      });
    });
  }
}

export default Sliders;
